<template>
<div class="map-timeline layout-2019">
  <div class="timeline-area">
    <div class="timeline">
      <!--타이틀-->
      <div class="header">
        타임라인
        <span style="color:#999">최근 24시간 발생정보</span>
        <div>
          <i @click="openTablePopup" class="fas fa-external-link-square-alt"></i>
        </div>
      </div>
      <!--체크박스-->
      <el-checkbox-group v-model="filterTypes" @change="onChangeFilterType">
        <el-checkbox v-for="button in filterTypeButtonList" :label="button.type" :key="button.type">{{ button.label }}</el-checkbox>
      </el-checkbox-group>
      <!-- 대상 필터 -->
      <div class="obj-filter">
        <div>
          <el-autocomplete
            ref="searchInput"
            style="width: calc(100% - 65px); vertical-align: middle;"
            popper-class="map-timeline-filter-popover"
            placeholder="장비명, IP 검색"
            v-model="searchText"
            :fetch-suggestions="querySearchAsync"
            :trigger-on-focus="false"
            :popper-append-to-body="false"
            size="mini"
            @blur="onBlur"
            @select="addFilterObj">
            <span class="el-input__icon" style="pointer-events: none;" slot="suffix">
              <i class="el-input__icon el-icon-search" style="margin-right:4px;"></i>
            </span>
            <template slot-scope="{ item }">
              <div v-if="item.empty === true" class="no-data">
                검색 결과가 없습니다.
              </div>
              <div v-else>
                <div class="name">
                  <span class="type">{{ item.objtypeName || '-' }}</span>
                  <span>{{ item.objName || '-' }}</span>
                </div>
                <span class="ipaddress">{{ item.ipaddress || '-' }}</span>
              </div>
            </template>
          </el-autocomplete>
          <el-tag class="label" size="small" style="cursor:pointer; margin-left: 5px;" @click="removeFilterObj(null)">초기화</el-tag>
        </div>
        <div style="margin-top: 5px;" v-if="!isEmpty(filterObjs)">
          <el-tag
            v-for="(obj, index) in filterObjs"
            :key="obj.objId"
            :disable-transitions="false"
            closable
            size="mini"
            class="mr-r4"
            @close="removeFilterObj(index)">
            {{obj.objName}}
          </el-tag>
        </div>
      </div>
      <el-scrollbar ref="scrollbar" style="margin-top: 10px;">
        <div class="d-wrapper">
          <div class="details">
            <li v-for="(timeline, index) in getTimelineList" :key="index" class="normal">
              <div class="status" :style="`background-color: ${getTimelineColor(timeline)}`"></div>
              <div class="time">{{ timeline.timestamp.split('.')[0] }}</div>
              <div class="message c-pointer" @click="onTimelineClick(timeline)">
                <span v-if="timeline.eventDynamicThresholdFlag === 'Y' && timeline.timelineType === 'EVENT'" class="text-red">
                  [동적]
                </span>
                <span class="text-blue">{{ timeline.timelineTarget }}</span>
                <div>
                  {{ timeline.timelineMessage }}
                </div>
                <div class="event" :style="`background-color: ${getTimelineColor(timeline)}`">{{getEventLevelName(timeline)}}</div>
              </div>
            </li>
          </div>
        </div>
      </el-scrollbar>
      <w-map-timeline-table-popup ref="mapTimelineTablePopup"></w-map-timeline-table-popup>
    </div>
  </div>
  <el-tooltip content="타임라인 숨기기" placement="left" v-if="isTimelineExpand">
    <div class="timeline-collapse" @click="onClickCollapse">
      <!-- style 추가 191219 sohong-->
      <i class="far fa-chevron-right" style="position:relative;left:3px"></i>
    </div>
  </el-tooltip>
  <div v-else class="timeline-mini event-badge">
    <el-tooltip :content="type.label" placement="left" v-for="type in filterTypeButtonList" :key="type.type" :ref="type.type">
      <div class="timeline-item" @click="onClickMini(type.type)">
        <el-badge :value="miniCount[type.type] > 99 ? '99+' : miniCount[type.type]">
          <div :class="['timeline-icon', type.type]">
          </div>
        </el-badge>
      </div>
    </el-tooltip>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import Velocity from 'velocity-animate';

import moment from 'moment';

import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import reduce from 'lodash/reduce';
import forEach from 'lodash/forEach';
import uniq from 'lodash/uniq';
import find from 'lodash/find';

import { MapInfo } from '@/views/topologymap/js/maps';
import Base from '@/mixins/topologymap/base';
import { openFaultAnalysisPopup } from '@/utils/event';
import { getDate } from '@/utils/date';
import MapAPI from '@/api/topologymap/common';
import WMapTimelineTablePopup from '@/views/topologymap/components/popup/MapTimelineTablePopup';

const TASK_NAME = 'map_timeline';

export default {
  name: 'WMapTimeline',
  mixins: [Base],
  components: {
    WMapTimelineTablePopup,
  },
  data() {
    return {
      isEmpty,
      searchText: '',
      isLoading: false,
      defaultFilterTypes: ['EVENT', 'TROUBLE_TICKET', 'CONFIG_CHANGE', 'WORK'],
      filterTypes: ['EVENT', 'TROUBLE_TICKET', 'CONFIG_CHANGE', 'WORK'],
      filterTypeButtonList: [
        {
          type: 'EVENT',
          label: '이벤트',
        },
        {
          type: 'TROUBLE_TICKET',
          label: '장애티켓',
        },
        {
          type: 'CONFIG_CHANGE',
          label: '구성변경',
        },
        {
          type: 'WORK',
          label: '작업관리',
        },
      ],
      miniCount: this.getDefaultMiniCount(),
      timelineList: [],
      objList: [],
      filterObjs: [],
      searchObjs: [],
      objSearchLoading: false,
      cancelToken: null,
    };
  },
  computed: {
    isEmptyValue() {
      return this.searchText === undefined || this.searchText === null || this.searchText === '';
    },
    eventlevelInfo() {
      return this.$store.getters.eventlevelInfo;
    },
    getTimelineList() {
      return this.timelineList.filter((value) => {
        // 필터타입에 속하지 않는 데이터일 경우 = false
        // 필터타입에는 속하지만 관리대상 필터 값이 있으면서 이에 속하지 않을 경우 = false
        // 그외 true
        if (!this.filterTypes.includes(value.timelineType)) {
          return false;
        } else if (!isEmpty(this.filterObjs)) {
          if (!find(this.filterObjs, (obj) => value.objIds.includes(obj.objId))) {
            return false;
          }
        }
        return true;
      });
    },
  },
  watch: {
    isTimelineExpand(isExpand) {
      if (isExpand) {
        this.loadData();
      } else {
        this.initData();
      }

      this.$nextTick(() => {
        const graph = MapInfo.getInstance(this).getGraph();
        const canvas = MapInfo.getInstance(this).getCanvas();

        if (graph && canvas) {
          graph.updateViewport();
          canvas.updateZoom();
        }
      });
    },
  },
  created() {
    this.$store.commit('setTimelineExpand', localStorage.getItem('mapTimelineExpand') === 'true');
  },
  mounted() {
    MapInfo.getInstance(this).addMapCompleteCallback(this.startTask);
    MapInfo.getInstance(this).addMapClearCallback(this.removeTask);
  },
  beforeDestroy() {
    this.removeTask();
  },
  methods: {
    initData() {
      this.timelineList = [];
      this.objList = [];
      this.filterObjs = [];
      this.searchObjs = [];
      this.objSearchLoading = false;
      this.miniCount = this.getDefaultMiniCount();
      this.isLoading = false;
      this.showAlert();
    },
    startTask() {
      this.loadData();

      this.$taskManager.createTask(TASK_NAME, 10, this.loadData);
      this.$taskManager.startTask(TASK_NAME);
    },
    removeTask() {
      this.initData();
      this.cancelLoadData();

      this.$taskManager.removeTask(TASK_NAME);
    },
    cancelLoadData() {
      if (this.cancelToken) {
        this.cancelToken.cancel();
      }
    },
    loadData() {
      const mapId = this.currentMapId;
      if (this.isLoading || this.isEditMode || !mapId) {
        return;
      }

      this.cancelLoadData();
      this.cancelToken = axios.CancelToken.source();

      this.isLoading = true;
      MapAPI.getTimelineDataOfCurrentMap({ mapId }, this.cancelToken.token).then((response) => {
        const responseData = response.data.data;

        if (!this.isTimelineExpand) {
          const changeTypes = [];

          this.miniCount = reduce(responseData.timelineDataList, (result, value, index) => {
            if (index === 0) {
              result.TIME = getDate(value.timestamp);
            }

            if (getDate(value.timestamp) > this.miniCount.TIME) {
              result[value.timelineType] += 1;
              changeTypes.push(value.timelineType);
            }

            return result;
          }, cloneDeep(this.miniCount));

          this.showAlert(uniq(changeTypes));
        } else {
          this.timelineList = responseData.timelineDataList;
          this.objList = responseData.objList;
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    showAlert(types) {
      if (!isEmpty(types)) {
        forEach(types, (type) => {
          const el = !isEmpty(this.$refs[type]) && this.$refs[type][0].$el;
          if (el) {
            Velocity(el, {
              opacity: 0,
            }, {
              loop: 30,
              duration: 500,
            });
          }
        });
      } else {
        forEach(this.defaultFilterTypes, (type) => {
          const el = !isEmpty(this.$refs[type]) && this.$refs[type][0].$el;
          if (el) {
            Velocity(el, 'finish', true);
            el.style.opacity = null;
          }
        });
      }
    },
    /**
     * 타임라인 색상 반환
     * @author jeee12
     * @param  {[type]} eventlevelId [description]
     */
    getTimelineColor(data) {
      const defaultColor = '#7785aa';
      if (!isEmpty(data.eventlevelId) && !isEmpty(this.eventlevelInfo)) {
        const eventInfo = this.eventlevelInfo[data.eventlevelId];
        return !isEmpty(eventInfo) ? eventInfo.eventlevelColorBg : defaultColor;
      }
      return defaultColor; // 로드 시점문제로 인해
    },
    onTimelineClick(row) {
      const objIds = row.objIds;
      if (!isNil(objIds)) {
        if (row.timelineType === 'EVENT') {
          openFaultAnalysisPopup(row.timelineTargetId);
        } else {
          this.$store.dispatch('openEventTimelinePopup', row);
        }
      }
    },
    getEventLevelName(data) {
      if (!isEmpty(this.eventlevelInfo) || !isNil(data.eventlevelId)) {
        const eventlevel = this.eventlevelInfo[data.eventlevelId];
        return isNil(eventlevel) ? '' : eventlevel.eventlevelName;
      }
      return '';
    },
    openTablePopup() {
      this.$refs.mapTimelineTablePopup.open();
    },
    querySearchAsync(query, cb) {
      if (this.isEmptyValue) {
        cb([]);
      } else {
        const searchResult = this.objList.reduce((accumulator, item) => {
          if (item.objName.toLowerCase().indexOf(query.toLowerCase()) > -1) {
            accumulator.push({
              objId: item.objId,
              objtypeName: item.objtypeName,
              objName: item.objName,
              ipaddress: item.ipaddress,
            });
          } else if (!isEmpty(item.ipaddress) && item.ipaddress.indexOf(query) > -1) {
            accumulator.push({
              objId: item.objId,
              objtypeName: item.objtypeName,
              objName: item.objName,
              ipaddress: item.ipaddress,
            });
          }
          return accumulator;
        }, []);

        cb(!isEmpty(searchResult) ? searchResult.slice(0, 10) : [{
          empty: true,
        }]);
      }
    },
    onClickCollapse() {
      this.$store.commit('setTimelineExpand', false);
    },
    onClickMini(type) {
      this.filterTypes = [type];
      this.$store.commit('setTimelineExpand', true);
    },
    onChangeFilterType() {
      this.timelineList = cloneDeep(this.timelineList);
    },
    getDefaultMiniCount() {
      return {
        EVENT: 0,
        TROUBLE_TICKET: 0,
        CONFIG_CHANGE: 0,
        WORK: 0,
        TIME: moment().toDate(),
      };
    },
    onBlur() {
      // this.$refs.searchInput.close();
      this.$refs.scrollbar.update();
    },
    addFilterObj(item) {
      this.searchText = '';

      if (!find(this.filterObjs, ['objId', item.objId])) {
        this.filterObjs.push(item);
      }
    },
    removeFilterObj(idx) {
      if (idx !== null) {
        this.filterObjs.splice(idx, 1);
      } else {
        this.filterObjs = [];
      }
    },
  },
};
</script>

<style lang="scss">
.map-timeline {
  position: relative;
  height: 100%;
  // box-shadow: 0 0 3px 0 rgba(0,0,0,0.2), 0 0px 5px 0 rgba(0,0,0,0.2);
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2), 0 0px 2px 0 rgba(0, 0, 0, 0.2);

  .timeline-area {
    height: 100%;
    padding: 15px;

    // base.scss에 있는 내용을 덮어 쓴다.
    .timeline {
      margin: 0;
      width: auto;
      float: none;
      height: 100%;
      padding: 0;
      overflow: hidden;
      box-shadow: none;
      max-height: none;
      display: flex;
      flex-direction: column;

      // 타임라인 장비 필터 영역
      .obj-filter {
        background: #f6f6f7;
        border-left: 3px solid #e2e5ec;
        padding: 9px;
      }

      .scrollbar {
        margin-top: 10px;
        flex: 1;
      }

      // 브라우저 크기가 줄어들었을 때 이벤트 등급 표현되는 막음
      .details li .event {
        display: none !important;
      }
    }
  }

  // 타임라인 축소 버튼
  // 수정 191219 sohong
  .timeline-collapse {
    width: 18px;
    height: 50px;
    position: absolute;
    top: 50%;
    left: -18px;
    color: #8a8a8a;
    background: white;
    line-height: 50px;
    text-align: center;
    border: 1px solid #ddd;
    border-right: none;
    // box-shadow: -2px 0px 3px 0 rgba(0, 0, 0, 0.2) !important;
    box-shadow: -1px 0 2px 0 rgba(0, 0, 0, 0.07);
    cursor: pointer;
    border-radius: 6px 0px 0px 6px;
  }

  .timeline-mini {
    position: absolute;
    top: calc(50% - 80px);
    left: -42px;
    width: 48px;
    background: #EAF1F9;
    padding: 10px 8px;
    border: 1px solid #c7d2df;
    box-shadow: 0 0px 3px 0 rgba(0, 0, 0, 0.15);
    // box-shadow: 0 0 3px 0 rgba(0,0,0,0.2), 0 0px 5px 0 rgba(0,0,0,0.2);
    border-radius: 5px 0px 0px 5px;

    .timeline-item {
      width: 32px;
      height: 32px;
      border-radius: 3px;
      cursor: pointer;

      &:not(:last-child) {
        margin-bottom: 5px;
      }

      &:hover {
        // background-color: #dddddd;
      }

      .el-badge {
        position: relative;
        top: 13px;
        left: 1px;
        right: auto;

        .timeline-icon {
          width: 16px;
          height: 15px;
        }

        .el-badge__content.is-fixed {
          top: -3px;
          border: 1px solid #eaf1f9;
        }
      }
    }
  }

  .el-select__input.is-mini {
    font-size: 12px;
  }
}
// 장비 검색 결과 Popover
.map-timeline-filter-popover {
  width: 300px !important;
  left: -10px !important;

  .no-data {
    text-align: center;
    font-size: 12px;
    line-height: 25px;
  }

  &.el-autocomplete-suggestion li {
    & > div {
      height: 25px;
      margin: 5px 0px;

      .name {
        font-size: 12px;
        line-height: 15px;
        vertical-align: bottom;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #333;

        .type {
          float: right;
          font-size: 10px;
          color: #bababa;
        }
      }

      .ipaddress {
        font-size: 11px;
        line-height: 11px;
        vertical-align: top;
        color: #767676;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/monitoring/MapTimeline.vue